import { Facebook, Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId, COMPANY } from "../lib/site";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1 0-5.18c.27 0 .53.04.77.12V9.69a5.7 5.7 0 0 0-.77-.05A5.68 5.68 0 1 0 15.54 15.3V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.24-1.48z" />
  </svg>
);

const SOLUTIONS = ["CCTV", "Control de acceso", "Redes", "Automatización", "Software"];
const COMPANY_LINKS = [
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Tecnología", href: "#tecnologia" },
  { label: "Contacto", href: "#contacto" },
];

export const Footer = ({ contact = {}, socials = {} }) => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-glg-black">
    <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
      <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div className="max-w-sm">
          <div className="rounded-2xl bg-white/[0.03] p-3 inline-block">
            <Logo size="h-10" />
          </div>
          <p className="mt-5 text-sm font-medium text-white/70">Seguridad · Tecnología · Innovación</p>
          <p className="mt-3 text-sm leading-relaxed text-white/45">
            Diseño, instalación, integración y desarrollo de soluciones tecnológicas en Honduras.
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Soluciones</h4>
          <ul className="space-y-2.5">
            {SOLUTIONS.map((s) => (
              <li key={s}>
                <button onClick={() => scrollToId("#servicios")} className="text-sm text-white/60 transition-colors hover:text-white">{s}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Empresa</h4>
          <ul className="space-y-2.5">
            {COMPANY_LINKS.map((l) => (
              <li key={l.href}>
                <button data-testid={`footer-link-${l.href.replace("#", "")}`} onClick={() => scrollToId(l.href)} className="text-sm text-white/60 transition-colors hover:text-white">{l.label}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Contacto</h4>
          <ul className="space-y-2.5 text-sm text-white/60">
            <li>{contact.phone || COMPANY.phoneDisplay}</li>
            <li><a href={`mailto:${contact.email || COMPANY.email}`} className="transition-colors hover:text-white">{contact.email || COMPANY.email}</a></li>
            <li>{contact.location || COMPANY.location}</li>
            <li>{contact.website || COMPANY.website}</li>
          </ul>
          <div className="mt-5 flex gap-2">
            {socials.facebook && <a href={socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/60 hover:text-white"><Facebook className="h-4 w-4" /></a>}
            {socials.instagram && <a href={socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/60 hover:text-white"><Instagram className="h-4 w-4" /></a>}
            {socials.tiktok && <a href={socials.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/60 hover:text-white"><TikTokIcon className="h-4 w-4" /></a>}
          </div>
        </div>
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
        <p className="text-xs text-white/40">© 2026 {COMPANY.name}. Todos los derechos reservados.</p>
        <p className="text-xs text-white/40">Honduras · {contact.website || COMPANY.website}</p>
      </div>
    </div>
  </footer>
);
